let copiedTask = null;

export const setCopiedTask = (task) => {
  copiedTask = task;
};

export const getCopiedTask = () => copiedTask;

export const clearCopiedTask = () => {
  copiedTask = null;
};
